import { observer } from 'mobx-react'
import { useContext, useEffect, useState } from 'react'
import { Onfido } from 'onfido-sdk-ui'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@methods/axiosConfig'
import { devLog } from '@methods/devLog'
import { LoadingSpinner } from '@components/Generic'
import { getOnfidoTheme } from '@/methods/getOnfidoTheme'
import { forceRedirect } from '@/methods/forceRedirect'
import { SignicatBranding } from '@/components/SignicatBranding/SignicatBranding'
import { API_URL } from '@constants/apiUrl'

interface PostStartOnfidoResponse {
  sdkToken: string
  steps: []
}

export const OnfidoPage = observer(() => {
  const store = useContext(StoreContext)
  const { language } = store.TranslationsState
  const [isLoading, setIsLoading] = useState(true)

  async function handleAuth() {
    setIsLoading(true)

    try {
      const { data } = await axiosInstance.post<PostStartOnfidoResponse>(
        `${API_URL}/onfido-v2/start-session`,
        {},
        {
          withCredentials: true,
        }
      )

      mountOnfido(data)
    } catch (e) {
      devLog(e)
    }
  }

  const mountOnfido = (onfidoData: PostStartOnfidoResponse): void => {
    Onfido.init({
      token: onfidoData.sdkToken,
      containerId: 'onfido-mount',
      enterpriseFeatures: {
        cobrand: {
          text: 'Signicat',
        },
      },
      theme: getOnfidoTheme(),
      language: language === 'en' ? 'en_US' : language,
      // language: 'nl',
      steps: onfidoData.steps,
      onComplete: () => {
        forceRedirect(`${API_URL}/onfido-v2/complete`)
      },
    })

    setIsLoading(false)
  }

  useEffect(() => {
    handleAuth()
  }, [])

  if (isLoading) {
    return (
      <div className="page-container p-0 mobile-m-10 mobile-p-0">
        <LoadingSpinner />
        <SignicatBranding width="560px" hideOnMobile />
      </div>
    )
  } else {
    return (
      <div className="generic__onfido__mount" id="onfido-mount">
        <SignicatBranding width="560px" hideOnMobile />
      </div>
    )
  }
})
